/**
 * @typedef {import('./Props').default} Props
 */

import { translate } from '../../../../Internationalization';
import InfoPopover from '../../../../../shared/Popover/Popover';
import React from 'react';
import LeadDate from 'App/shared/LeadDate/LeadDate';

export default class LeadDateBoard extends React.Component {
	get #date() {
		return this.#sortContact()?.map((contact) => (
			<li className="list-item" key={contact.id}>
				<header className="justified-row items-center">
					<section className="flex items-center justify-between hl-ms mr-2">
						{contact?.name}
					</section>
					<section className="flex items-center">
						<LeadDate
							className="h-ms-1"
							last_avm_request={contact.last_avm_request_at}
							leadScore={contact.leadScore}
							leadScores={contact.leadScores}
						/>
					</section>
				</header>
			</li>
		));
	}

	/**
	 * @returns {Props['contactList']}
	 */
	#sortContact() {
		const sortedContacts = [...this.props.contactList].sort((a, b) => {
			if (!a.last_avm_request_at && !b.last_avm_request_at) {
				return 0;
			}

			if (!a.last_avm_request_at) {
				return 1;
			}

			if (!b.last_avm_request_at) {
				return -1;
			}

			return (
				new Date(b.last_avm_request_at).getTime() -
				new Date(a.last_avm_request_at).getTime()
			);
		});

		return sortedContacts;
	}

	render() {
		return (
			<section className="mt-10">
				<section className="card card-border-light">
					<header className="card-header bg-theme-light text-theme-fg-light">
						<div className="h-ms-1">
							{translate(
								'agent.pages.dashboard.avmLead_board.title'
							)}
							<InfoPopover
								content={translate(
									'agent.pages.dashboard.avmLead_board.description'
								)}
							/>
						</div>
					</header>
					<ul className="list-group card-list divided px-3 relative">
						{this.#date}
					</ul>
				</section>
			</section>
		);
	}
}
